module.exports = __webpack_public_path__ + "img/circle-location-arrow.db494f81.svg";